import { Component } from 'react';
import { connect } from 'react-redux';
import { CSSTransition } from 'react-transition-group';
import * as FormActions from 'MeetingsLib/redux/actions/FormActions';
import emptyFunction from 'react-utils/emptyFunction';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Box } from 'foundations-components/transitional/components/Box';
import { CardWrapper, CardSection } from 'foundations-components/transitional/components/Card';
import DatePickerSection from 'MeetingsLib/components/sections/DatePickerSection';
import FreemiumBookingUpgradeLink from 'MeetingsLib/components/freemium/FreemiumBookingUpgradeLink';
import TimeOptionsSection from 'MeetingsLib/components/sections/TimeOptionsSection';
import PropertyFormV2 from 'MeetingsLib/components/sections/PropertyFormV2';
import PaymentForm from '../payments/PaymentIframe';
import { BOOKING_STEPS } from 'MeetingsLib/constants/steps';
import { getRecaptchaEnabled } from '../../selectors/BookInfoSelectors';
import ErrorBoundary from '../ErrorBoundary';
import EmailFormV2 from '../sections/EmailFormV2';
import { View } from 'foundations-components/components/View';
import CookieSettingsLink from '../internalCompliance/CookieSettingsLink';
//#endregion Imports
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class FullSizeBookingPage extends Component {
  constructor(props) {
    super(props);
    this.getContainerProps = () => {
      const {
        isSalesStarter,
        canTroubleshoot,
        embedded,
        currentStep
      } = this.props;
      const isPaymentStep = currentStep === BOOKING_STEPS.PAYMENT;
      const isPropertyFormStep = !currentStep || currentStep === BOOKING_STEPS.YOUR_INFO;
      const isOnlyMaxWidthContainer = !embedded && isPropertyFormStep;

      // Base props
      const baseProps = {
        direction: 'column',
        minBlockSize: '0',
        inlineSize: '100%',
        marginInline: '1000',
        // equivalent to m-x-10
        paddingBlockStart: !isSalesStarter && !canTroubleshoot && !embedded ? '1200' : '400' // p-top-12 vs p-top-4
      };

      // Container sizing based on step
      if (isPaymentStep) {
        return Object.assign({}, baseProps, {
          maxInlineSize: '1000px',
          // fullsize-payments-container
          blockSize: 'auto',
          marginBlockStart: '-400' // fullsize-payments-top
        });
      } else if (isOnlyMaxWidthContainer) {
        return Object.assign({}, baseProps, {
          maxInlineSize: '850px' // fullsize-container-max-width
        });
      } else {
        return Object.assign({}, baseProps, {
          maxInlineSize: '850px',
          // fullsize-container
          blockSize: '690px',
          paddingBlockEnd: '100'
        });
      }
    };
    this.renderEmailForm = () => {
      const {
        branding,
        welcomeScreenInfo,
        meetingChangeId,
        EmailFormMarker
      } = this.props;
      return /*#__PURE__*/_jsx(EmailFormV2, {
        branding: branding,
        compact: false
        /*  @ts-expect-error Jun-18-2025, 19:10UTC fix types  */,
        logoUrl: welcomeScreenInfo.logoUrl,
        meetingChangeId: meetingChangeId
        /*  @ts-expect-error Jun-18-2025, 19:10UTC fix types  */,
        title: welcomeScreenInfo.title,
        useCompanyLogo: welcomeScreenInfo.useCompanyLogo
        /*  @ts-expect-error Jun-18-2025, 19:10UTC fix types  */,
        description: welcomeScreenInfo.description,
        EmailFormMarker: EmailFormMarker
      });
    };
    this.renderDateTimeStep = () => {
      const {
        avatar,
        companyAvatar,
        headline,
        displayAvatarOption,
        embedded,
        branding,
        profile,
        isFetchingPublicAvailability,
        isSalesStarter,
        DatePickerMarker,
        TimePickerMarker,
        isPreviewed
      } = this.props;

      // Calculate maxBlockSize for embedded non-sales-starter case
      const containerMaxBlockSize = embedded && !isSalesStarter ? '613px' : undefined;
      return /*#__PURE__*/_jsx(CardWrapper, {
        padding: "0",
        flexDirection: "column",
        blockSize: "100%",
        "data-selenium-test": "booking-schedule-step",
        children: /*#__PURE__*/_jsx(CardSection, {
          padding: "0",
          blockSize: "100%",
          flexDirection: "column",
          children: /*#__PURE__*/_jsxs(TFlex, {
            direction: "column",
            align: "stretch",
            blockSize: "100%",
            children: [/*#__PURE__*/_jsxs(TFlex, {
              direction: "row",
              align: "stretch",
              blockSize: "100%",
              maxBlockSize: containerMaxBlockSize,
              children: [/*#__PURE__*/_jsx(Box, {
                basis: "50%",
                children: /*#__PURE__*/_jsx(DatePickerSection, {
                  compact: false,
                  avatar: avatar,
                  companyAvatar: companyAvatar,
                  branding: branding,
                  displayAvatarOption: displayAvatarOption,
                  headline: headline,
                  profile: profile,
                  DatePickerMarker: DatePickerMarker,
                  TimePickerMarker: TimePickerMarker,
                  isPreviewed: isPreviewed
                })
              }), /*#__PURE__*/_jsx(Box, {
                basis: "50%",
                children: /*#__PURE__*/_jsx(TimeOptionsSection, {
                  compact: false,
                  branding: branding,
                  profile: profile,
                  goToPreviousStep: emptyFunction,
                  isFetchingPublicAvailability: isFetchingPublicAvailability,
                  TimePickerMarker: TimePickerMarker
                })
              })]
            }), !isSalesStarter && /*#__PURE__*/_jsx(Box, {
              marginBlockStart: "100",
              children: /*#__PURE__*/_jsx(FreemiumBookingUpgradeLink, {
                embedded: embedded
              })
            })]
          })
        })
      }, "full-datetime");
    };
    this.renderPropertyForm = () => {
      const {
        branding,
        canSubmitInitialPropertyForm,
        submittingMeeting,
        resetEventDateTime
      } = this.props;
      return /*#__PURE__*/_jsx(PropertyFormV2, {
        branding: branding,
        canSubmitInitialPropertyForm: canSubmitInitialPropertyForm,
        goToPreviousStep: resetEventDateTime,
        submittingMeeting: submittingMeeting,
        compact: false
      }, "full-property");
    };
    this.renderStep = () => {
      const {
        shouldShowEmailForm,
        bookingLifecycle,
        emailFormState
      } = this.props;
      if (shouldShowEmailForm && !emailFormState) {
        return this.renderEmailForm();
      }
      if (!bookingLifecycle.event.dateString || !bookingLifecycle.event.dateTime) {
        return this.renderDateTimeStep();
      }
      return this.renderPropertyForm();
    };
    this.renderPaymentForm = () => {
      const {
        resetFormState,
        resetConsentResponses,
        branding,
        submittingMeeting,
        recaptchaEnabled
      } = this.props;
      return /*#__PURE__*/_jsx(View, {
        marginBlockStart: "1200",
        children: /*#__PURE__*/_jsx(ErrorBoundary, {
          children: /*#__PURE__*/_jsx(PaymentForm, {
            goToPreviousStep: () => {
              resetFormState();
              resetConsentResponses();
            },
            branding: branding,
            compact: false,
            submittingMeeting: submittingMeeting,
            recaptchaEnabled: recaptchaEnabled
          }, "payment-form")
        })
      });
    };
    this.renderStepWithPayment = () => {
      const {
        shouldShowEmailForm,
        bookingLifecycle,
        emailFormState,
        formState,
        legalConsentValid
      } = this.props;
      if (shouldShowEmailForm && !emailFormState) {
        return this.renderEmailForm();
      }
      if (!bookingLifecycle.event.dateString || !bookingLifecycle.event.dateTime) {
        return this.renderDateTimeStep();
      }
      if (!formState || !legalConsentValid) {
        return this.renderPropertyForm();
      }
      return this.renderPaymentForm();
    };
    this.state = {
      doTransition: false
    };
  }
  componentDidUpdate(prevProps) {
    const isNewFormStep = this.props.currentStep && prevProps.currentStep !== this.props.currentStep;
    if (isNewFormStep) {
      this.setState({
        doTransition: true
      });
    }
  }
  render() {
    const {
      isPaidMeeting
    } = this.props;
    const containerProps = this.getContainerProps();
    return /*#__PURE__*/_jsxs(TFlex, Object.assign({}, containerProps, {
      children: [/*#__PURE__*/_jsx(CSSTransition, {
        classNames: "step-animation",
        timeout: 500,
        exit: false,
        in: this.state.doTransition,
        onEntered: () => {
          this.setState({
            doTransition: false
          });
        },
        children: /*#__PURE__*/_jsx(View, {
          minBlockSize: "0",
          inlineSize: "100%",
          blockSize: "100%",
          flexDirection: "column",
          children: isPaidMeeting ? this.renderStepWithPayment() : this.renderStep()
        })
      }), /*#__PURE__*/_jsx(CookieSettingsLink, {
        includeFooterWrapper: true
      })]
    }));
  }
}
export default connect(state => ({
  /*  @ts-expect-error Jun-18-2025, 19:10UTC fix types  */
  isSalesStarter: state.isSalesStarter,
  /*  @ts-expect-error Jun-18-2025, 19:10UTC fix types  */
  isRescheduling: state.isRescheduling,
  /*  @ts-expect-error Jun-18-2025, 19:10UTC fix types  */
  meetingChangeId: state.meetingChangeId,
  /*  @ts-expect-error Jun-18-2025, 19:10UTC fix types  */
  recaptchaEnabled: getRecaptchaEnabled(state)
}), FormActions)(FullSizeBookingPage);